import { newOrderFromUser } from './orders/newOrderFromUser';
import { cancelOrderFromUser } from './orders/cancelOrderFromUser';
import { newCallFromUser } from './calls/newCallFromUser';
import { cancelCallFromUser } from './calls/cancelCallFromUser';
import { syncEventsComplete } from './orders/syncEventsComplete';
import { syncEventsAssign } from './orders/syncEventsAssign';
import { syncCallCompleted } from './calls/syncCallCompleted';
import { updateMenuChanges } from './updateMenuChanges';

export const messageHandler = (message, reducers, data, connection) => {
  try {
    const { data: dataString } = message;
    const messageData = JSON.parse(dataString);
    // console.log('NEW MESSAGE:', messageData);
    switch (messageData.type) {
      case 'ORDER_NEW':
        newOrderFromUser(messageData, reducers, data, connection);
        break;
      case 'ORDER_CANCEL':
        cancelOrderFromUser(messageData, reducers, data, connection);
        break;
      case 'SYNC_COMPLETE_POINT':
        syncEventsComplete(messageData, reducers, data, connection);
        break;
      case 'SYNC_EVENTS_ASSIGNED':
        syncEventsAssign(messageData, reducers, data, connection);
        break;

      case 'CALL_NEW':
        newCallFromUser(messageData, reducers, data, connection);
        break;
      case 'CALL_CANCEL':
        cancelCallFromUser(messageData, reducers, data, connection);
        break;
      case 'SYNC_CALL_CONFIRMED':
        syncCallCompleted(messageData, reducers, data, connection);
        break;

      case 'MENU_CHANGE':
        updateMenuChanges(messageData, reducers, data, connection);
        break;

      default:
        console.log('DEFAULT IN SWITCH AT onWSMessage', messageData);
        break;
    }
  } catch (error) {
    console.log('ERROR ON MESSAGE HANDLER', error);
  }
};
